import TubeSpit from './TubeSpit'

export default TubeSpit
